<template>
  <div class="svoi-pagination">
    <span v-if="showArrows" class="pagination-arrow" :class="{ '-disabled': !prevPage }" @click="setPage(prevPage)">
      <SvoiIcon icon="arrow/arrow-left-2" size="s" />
    </span>
    <div
      v-for="(page, index) in pages"
      :key="`page_${index}`"
      class="page-wrapper"
      :class="{ '-active': page.number === prepareActivePage, '-hovered': !!page.number }"
    >
      <span class="page" @click="setPage(page.number && page.number !== prepareActivePage ? page.number : undefined)">
        {{ page.title }}
      </span>
    </div>
    <span v-if="showArrows" class="pagination-arrow" :class="{ '-disabled': !nextPage }" @click="setPage(nextPage)">
      <SvoiIcon icon="arrow/arrow-right-3" size="s" />
    </span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watchEffect } from 'vue-demi'
import { SvoiIcon } from '@svoi-ui/components/icon'
import type { PageInfo } from '@svoi-ui/interfaces/pagination'
import { isNumber } from '@svoi-ui/shared/utils/guards'
import { BasePaginationComponent, useBasePagination } from './BasePagination'

export default defineComponent({
  name: 'SvoiPaginationProgram',
  components: { SvoiIcon },
  props: {
    ...BasePaginationComponent.props
  },
  emits: ['change-page'],
  setup(props, { emit }) {
    const { prepareActivePage, getPages } = useBasePagination(props)

    const pages = ref<Array<PageInfo>>([])
    const prevPage = computed<number | undefined>(() =>
      prepareActivePage.value > 1 ? prepareActivePage.value - 1 : undefined
    )
    const nextPage = computed<number | undefined>(() =>
      prepareActivePage.value < props.totalPages ? prepareActivePage.value + 1 : undefined
    )

    const setPage = (value: number | undefined) => {
      if (isNumber(value) && value > 0 && value <= props.totalPages) {
        emit('change-page', value)
      }
    }

    watchEffect(() => {
      pages.value = getPages('')
    })

    return { prepareActivePage, pages, prevPage, nextPage, setPage }
  }
})
</script>

<style lang="scss">
@use '@svoi-ui/assets/scss/components/pagination.scss';
</style>
